import OverviewHeader from "./OverviewHeader";
import ProjectStatusBanner from "./ProjectStatusBanner";
import InvestorPurchaseCard from "./InvestorPurchaseCard";
import ProjectLastNotifications from "./ProjectLastNotifications";
import FundingRecievedBanner from "./FundingRecievedBanner";

export default function Overview({ projectData, isLoading = false }: any) {
    const data = projectData

    return (
        <div>
            <OverviewHeader data={data} />
            <div className="flex flex-col gap-4">
                <ProjectStatusBanner data={data} />
                <section className="grid min-h-[145px]">
                    <FundingRecievedBanner projectData={projectData} />
                </section>
                <section className="grid grid-cols-1 xl:grid-cols-2 gap-7">
                    <InvestorPurchaseCard projectData={projectData} isLoading={isLoading} />
                    <ProjectLastNotifications />
                </section>
            </div>
        </div>
    )
}
